import type { FC } from 'react';

import style from './style.module.scss';

interface Props {
  position: number;
}

const Dota2PositionIndicator: FC<Props> = ({ position }) => (
  <div className={style.indicator}>{`P${position}`}</div>
);

Dota2PositionIndicator.displayName = 'Dota2PositionIndicator';

export default Dota2PositionIndicator;
